import type { ThemeTemplate } from "../types";

// English comment: Travel theme (generic starter).
export const THEME_TRAVEL: ThemeTemplate = {
  id: "theme_travel",
  name: "Wakacje (generyczny)",
  target_physical_pages: 64,
  single_first: [
    { type: "text", role: "heading", box: { x: 0.08, y: 0.12, w: 0.84, h: 0.16 }, text: "Wakacje" },
    { type: "text", role: "body", box: { x: 0.12, y: 0.32, w: 0.76, h: 0.1 }, text: "Miejsce / data" },
    { type: "image", box: { x: 0.12, y: 0.46, w: 0.76, h: 0.44 } }
  ],
  single_last: [{ type: "text", role: "body", box: { x: 0.12, y: 0.12, w: 0.76, h: 0.22 }, text: "Dziękuję!" }],
  spread_cycle: [
    [
      { type: "image", anchor: "both", bleed: true, box: { x: 0, y: 0, w: 1, h: 1 } },
      { type: "shape", shape_id: "rectangle", anchor: "both", box: { x: 0.05, y: 0.05, w: 0.26, h: 0.1 }, fill_hex: "#111827" },
      { type: "text", role: "body", anchor: "both", box: { x: 0.07, y: 0.07, w: 0.22, h: 0.06 }, text: "Dzień 1" }
    ],
    [
      { type: "image", anchor: "left", box: { x: 0.12, y: 0.14, w: 0.88, h: 0.72 } },
      { type: "image", anchor: "right", box: { x: 0.08, y: 0.14, w: 0.8, h: 0.34 } },
      { type: "text", role: "body", anchor: "right", box: { x: 0.08, y: 0.52, w: 0.8, h: 0.34 }, text: "Notatki..." }
    ]
  ]
};
